import { useEffect, useState } from "react";
import { UserFilters } from "../../../types/filter";
import { useLazyGetVendedoresQuery } from "../../../api/vendedorApi";
import { VendedorItem } from "../../../types/vendedor";
import { CircularProgress } from "@mui/joy";
import { ErrorMessage } from "../../UtilitiesComponents/ErrorMessage";

interface Props {
    onOpenDetails?: (vendedor: VendedorItem) => void;
}

export function VendedorTable({ onOpenDetails }: Props) {

    const [trigger, { data: vendedores, isSuccess, isFetching, isError, isLoading }, lastPromiseInfo] = useLazyGetVendedoresQuery();

    const [filters, setFilters] = useState<UserFilters>({
        nombre: "",
        rol: "",
        status: "",
    });

    const openDetails = (vendedor: VendedorItem) => {
        if(onOpenDetails)
            onOpenDetails(vendedor);
    }

    const getVendedores = (filtros: UserFilters) => {
        try {
            trigger();
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getVendedores(filters);
    }, []);

    if(isFetching || isLoading)
        return (
        <div className="h-full flex justify-center items-center">
            <CircularProgress/>
        </div>
        );

    if(isError || !isSuccess)
        return (
        <div className="h-full flex justify-center">
            <div>
                <ErrorMessage customMessage>
                    Ha ocurrido un error al cargar la informacion. Intente mas tarde.
                </ErrorMessage>
            </div>
        </div>
        );

    return (
        <table className="w-full">
            <thead>
                <tr>
                    <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        Nombre
                    </th>
                    <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        Tipo
                    </th>
                    <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        Estado
                    </th>
                    <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        Detalles
                    </th>
                </tr>
            </thead>
            <tbody className="text-[14px]">
                {vendedores.map((vendedor, index) => (
                <tr key={index}
                    className="hover:bg-gray-100">
                    <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-[14px] font-semibold text-[#111827]">
                        {vendedor.nombre}
                    </td>
                    <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        {vendedor.tipo}
                    </td>
                    <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        {vendedor.activo ? "Activo" : "Inactivo"}
                    </td>
                    <td className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                        <p
                        className="cursor-pointer hover:text-blue-900 hover:underline"
                        onClick={() => openDetails(vendedor)}>
                            Detalles
                        </p>
                    </td>
                </tr>
                ))}
            </tbody>
        </table>
    );
}